import { render, staticRenderFns } from "./StatBreakdown.vue?vue&type=template&id=2354db49"
import script from "./StatBreakdown.vue?vue&type=script&lang=js"
export * from "./StatBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports